module.exports = __webpack_public_path__ + "img/phoenix_kedel_3.43485321.png";